var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"canal-vendas-cell"},[_c('ImagemDeTabela',{attrs:{"src":_vm.srcImagem,"alt":_vm.altTexto,"width":40,"height":40,"texto-sem-imagem":_vm.textoSemImagem}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }